import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=5f1dfed6&scoped=true&"
import script from "./VerifyEmail.vue?vue&type=script&lang=js&"
export * from "./VerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmail.vue?vue&type=style&index=0&id=5f1dfed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1dfed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1dfed6')) {
      api.createRecord('5f1dfed6', component.options)
    } else {
      api.reload('5f1dfed6', component.options)
    }
    module.hot.accept("./VerifyEmail.vue?vue&type=template&id=5f1dfed6&scoped=true&", function () {
      api.rerender('5f1dfed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/VerifyEmail.vue"
export default component.exports